// Use this to detect our screen resolution
const screenResolution = window.screen;

// This is based on our specs.
const isMobile = screenResolution.width <= 768;
const isTablet = screenResolution.width <= 1024;

// If it's false, do nothing.  But if it's a browser, we need to now determine if the event exists
// This is a better indication of whether something is mobile.
export { screenResolution, isMobile, isTablet };
